import React, { useState, useEffect, useRef } from "react";
import '../../src/assets/css/style.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCertificateDownload } from "../CertificateService";
import { QRCodeCanvas } from "qrcode.react";
import certificateFormate from "../assets/img/certificate_format.png";
import { getSignature } from '../CertificateService'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";


const BengaliCertificate = () => {
    const certificateRef = useRef();
    const [signatureData, setSignatureData] = useState({});
    const today = new Date();
    const currentYear = today.getFullYear();
    const location = useLocation();
    const applicationId = location.state?.applicationId;
    const [certificateDownloadData, setCertificateDownloadData] = useState(null);

    const [data, setData] = useState({
        "Applicant Name": "",
        "Application id": "",
        "Applied Certficate": "",
        "Pradhan Name": "",
        "Pradhan Designation": "",
        "Gram Panchayat Name": "",
        "Block Name": "",
        "District Name": "",
        "Valid Upto": "",
        "Certificate Validity checking link": ""
    });

    useEffect(() => {
        getCertificateDownload(applicationId).then(function (result) {
            const response = result?.data;
            setCertificateDownloadData(response);
            setData({
                "Applicant Name": response?.ApplicatNameBengali || "No Name",
                "Application id": response?.ApplicationId || "No Application Id",
                "Applied Certificate": [
                    response?.CharacterCertificate > 0 ? "Character Certificate" : null,
                    response?.IncomeCertificate > 0 ? "Income Certificate" : null,
                    response?.ResidenceCertificate > 0 ? "Residential Certificate" : null,
                    response?.SamePersonCertificate > 0 ? "Same Person Certificate" : null,
                    response?.DistanceCertificate > 0 ? "Distance Certificate" : null,
                ]
                    .filter(Boolean) // Remove null or falsy values
                    .join(", ") || "No Application Id",
                "Pradhan Name": response?.PradhanName,
                "Pradhan Designation": "প্রধান",
                "Gram Panchayat Name": response?.GPNameBeng,
                "Block Name": response?.BlockNameBeng,
                "District Name": response?.DistrictBeng,
                "Valid Upto": response?.ValidDate,
                "redirectUrl": "https://wbpms.in/citizen/#/certificate-check"

            })
            getSignature(response?.GpLGD).then(function (result) {
                const response = result?.data;
                console.log(response, "response");
                setSignatureData(response);
            });
        });
    }, [])

    const imageSrc = `data:image/jpeg;base64,${signatureData?.officerSignature}`;
    const handleDownload = async () => {
        try {
            console.log(certificateRef, "certificateRef.current");

            // Render the component into a canvas with lower resolution
            const canvas = await html2canvas(certificateRef.current, {
                scale: 1, // Reduce scale for smaller resolution
            });

            // Convert the canvas to an image with reduced quality
            const imgData = canvas.toDataURL("image/jpeg", 1); // Use JPEG with 70% quality to reduce size

            // Create a new PDF instance with optimized dimensions
            const pdf = new jsPDF({
                orientation: "portrait",
                unit: "px",
                format: [canvas.width, canvas.height], // Set PDF dimensions to match the canvas
            });

            // Add the image to the PDF with further compression
            pdf.addImage(imgData, "JPEG", 0, 0, canvas.width, canvas.height);

            // Save the PDF
            pdf.save("certificate.pdf");
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };

    const englishToBengaliNumbers = {
        "0": "০",
        "1": "১",
        "2": "২",
        "3": "৩",
        "4": "৪",
        "5": "৫",
        "6": "৬",
        "7": "৭",
        "8": "৮",
        "9": "৯",
    };

    const convertToBengaliNumber = (number) => {
        return number
            .toString()
            .split("")
            .map((digit) => englishToBengaliNumbers[digit] || digit)
            .join("");
    };

    const convertDateToBengaliFormat = (dateString) => {
        const [day, month, year] = dateString.split("."); // Split input by `.`
        const bengaliDay = convertToBengaliNumber(day);
        const bengaliMonth = convertToBengaliNumber(month);
        const bengaliYear = convertToBengaliNumber(year);

        return `${bengaliDay}.${bengaliMonth}.${bengaliYear}`;
    };


    // Example Usage
    const date = "17.11.2024";
    console.log(convertDateToBengaliFormat(date));


    return (

        <>
            <style>
                {`
          body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            background-image: url(${certificateFormate});
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            color: #333;
          }
        `}
            </style>
            {certificateDownloadData?.OthLang == "B" ?
                <div class="grid-container xyx" ref={certificateRef} style={{ position: "relative" }}>
                    {/* <img src={certificateFormate} style={{position:'absolute'}}/> */}
                    <div class="cell text-center">
                        <br></br>
                        <h4 style={{ marginTop: "15px" }}><b>{certificateDownloadData?.GPNameBeng}</b></h4>
                        <h5 style={{ marginTop: "-12px" }}><b>{signatureData?.gpAddressbeng}</b></h5>
                    </div>
                    <div class="cell">
                        <div class="grid-x grid-padding-x crtno" style={{ marginTop: "60px" }}>
                            <div class="large-6">
                                <p class="text-left">সার্টিফিকেট নম্বর :<b>{certificateDownloadData?.ApplicationId}</b></p>
                            </div>
                            <div class="large-6">
                                <p class="text-right">তারিখ:<b>{certificateDownloadData?.ApproveDate}</b></p>
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <div class="cell text-center">
                        <h4 style={{ marginBottom: "20px" }}>
                            <b><u>TO WHOM IT MAY CONCERN</u></b>
                        </h4>
                    </div>
                    <br></br>
                    <div class="cell text-center">
                        <p style={{ marginBottom: "20px" }}>
                            {/* <b><u>এই মর্মে শংসাপত্র দেওয়া যাইতেছে যে,</u></b> */}
                        </p>
                    </div>
                    <div class="grid-x grid-padding-x resi divmargin" style={{ marginBottom: "20px " }}>
                        <div class="cell large-10 medium-10 small-12">
                            <p>
                                এই মর্মে শংসাপত্র দেওয়া হচ্ছে যে, <b>{certificateDownloadData?.Gender === "Mr." ? "শ্রী" : certificateDownloadData?.Gender === "Mrs." ? "শ্রীমতি" : certificateDownloadData?.Gender === "Miss" ? "কুমারী" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b>, <b>{certificateDownloadData?.RelationGurdianBengali}</b> : <b>{certificateDownloadData?.GurdianNameBengali}</b>, <b>{certificateDownloadData?.AddressBengali}</b>, পোস্ট অফিস- <b>{certificateDownloadData?.PostOfficeBengali}</b>,  থানা- <b>{certificateDownloadData?.PoliceStationBengali}</b>, জেলা- <b>{certificateDownloadData?.DistrictBeng}</b>, পিন- <b>{certificateDownloadData?.PinBengali}</b> -এ স্থায়ীভাবে বসবাসকারী এবং আমার সুপরিচিত।
                                <br></br>
                                <br></br>
                                <b>{certificateDownloadData?.Gender === "Mr." ? "শ্রী" : certificateDownloadData?.Gender === "Mrs." ? "শ্রীমতি" : certificateDownloadData?.Gender === "Miss" ? "কুমারী" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b>, <b>{certificateDownloadData?.AddressBengali}</b>, পোস্ট অফিস- <b>{certificateDownloadData?.PostOfficeBengali}</b>,  থানা- <b>{certificateDownloadData?.PoliceStationBengali}</b>, জেলা- <b>{certificateDownloadData?.DistrictBeng}</b>, পিন- <b>{certificateDownloadData?.PinBengali}</b>, পশ্চিমবঙ্গের স্থায়ী বাসিন্দা।
                            </p>
                        </div>
                        
                            <div class="cell large-2 medium-2 small-12 text-right">
                                <img src={certificateDownloadData?.ApplicantImageBase64} style={{ width: "100%", border: "1px solid #000", padding: "5px", marginTop: "-40px" }} />
                            </div> 
                    </div>
                    {/* unmarried certificate */}
                    {certificateDownloadData?.UnmarriedCertificate > 0 ?
                        <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px" }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    আমার জানা মতে, <b>{certificateDownloadData?.Gender === "Mr." ? "শ্রী" : certificateDownloadData?.Gender === "Mrs." ? "শ্রীমতি" : certificateDownloadData?.Gender === "Miss" ? "কুমারী" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b> বর্তমানে অবিবাহিত।

                                </p>
                            </div>
                        </div>
                        : ""}

                    {/* caste certificate */}

                    {certificateDownloadData?.CastCertificate > 0 ?
                        <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px" }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    <b>{certificateDownloadData?.Gender === "Mr." ? "শ্রী" : certificateDownloadData?.Gender === "Mrs." ? "শ্রীমতি" : certificateDownloadData?.Gender === "Miss" ? "কুমারী" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b>, <b>{certificateDownloadData?.SubCast}</b> সম্প্রদায়ের অন্তর্ভুক্ত, যা <b>{certificateDownloadData?.Cast}</b> বিভাগের অন্তর্গত।

                                </p>
                            </div>
                        </div>
                        : ""}

                    {/* <!-- income --> */}
                    {certificateDownloadData?.IncomeCertificate > 0 ?

                        <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    তার <b>{certificateDownloadData?.IncomeFinYear}</b> আর্থিক বছরের জন্য সকল উৎস থেকে  মোট বার্ষিক পারিবারিক আয় আনুমানিক <b>{certificateDownloadData?.AnnualIncome}</b>/-  টাকা ( <b>{certificateDownloadData?.AnnualIncomeWoedBeng}</b> ) ।
                                </p>
                            </div>
                        </div> : ""}

                    {/* <!-- Distance --> */}
                    {certificateDownloadData?.DistanceCertificate > 0 ?

                        <div class="grid-x grid-padding-x distance divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    তার বাসস্থান এবং <b>{certificateDownloadData?.ResidenceLocation}</b> এর মধ্যে আনুমানিক দূরত্ব <b>{certificateDownloadData?.ResidenceDistance}</b> কিলোমিটার।
                                </p>
                            </div>
                        </div> : ""}

                    {/* <!-- Same Person --> */}
                    {certificateDownloadData?.SamePersonCertificate > 0 ?

                        <div class="grid-x grid-padding-x same divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    <b>{certificateDownloadData?.Gender === "Mr." ? "শ্রী" : certificateDownloadData?.Gender === "Mrs." ? "শ্রীমতি" : certificateDownloadData?.Gender === "Miss" ? "কুমারী" : ""}</b> <b>{certificateDownloadData?.ApplicantName}</b> এবং <b>{certificateDownloadData?.Gender === "Mr." ? "শ্রী" : certificateDownloadData?.Gender === "Mrs." ? "শ্রীমতি" : certificateDownloadData?.Gender === "Miss" ? "কুমারী" : ""}</b> <b>{certificateDownloadData?.SamePersonNewName}</b> একই ব্যক্তি । তার <b>{certificateDownloadData?.RelationGurdianBengali}</b> <b>{certificateDownloadData?.GurdianNameBengali}</b>। তার জন্ম তারিখ <b>{certificateDownloadData?.DOBBengali}</b>।
                                </p>
                            </div>
                        </div> : ""}

                    {/* Character Certificate/All  */}
                    {certificateDownloadData?.CharacterCertificate > 0 ?

                        <div class="grid-x grid-padding-x character divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    <b>{certificateDownloadData?.Gender === "Mr." ? "শ্রী" : certificateDownloadData?.Gender === "Mrs." ? "শ্রীমতি" : certificateDownloadData?.Gender === "Miss" ? "কুমারী" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b> একজন সৎ, দায়িত্বশীল ও প্রশংসনীয় নৈতিক চরিত্রের অধিকারী,ইহা আমার জ্ঞান ও বিশ্বাসমতে সত্য। আমি তার জীবনে সাফল্য কামনা করি।
                                </p>
                            </div>
                        </div> : ""}

                    <div class="cell">
                        <div class="grid-padding-x grid-x">
                            <div class="large-6 cell text-center">

                                <QRCodeCanvas value={JSON.stringify(data)}

                                    size={100}
                                />
                                <p class="text-center" style={{ fontSize: "10px" }}><i>https://wbpms.in</i></p>
                                <p class="text-center" style={{ fontSize: "10px" }}><i>Certificate Valid for 6 Months</i></p>
                            </div>

                            <div class="large-6 cell" style={{ marginTop: "30px" }}>

                                <div>
                                    {certificateDownloadData?.ApplicantImageBase64 ?
                                        <img
                                            src={imageSrc}
                                            alt="Signature"
                                            style={{
                                                height: "auto",
                                                position: "relative", // Aligns with the div
                                                top: "-2px",
                                                right: "-110px",
                                                maxWidth: "150px",

                                                // Moves the image upwards to touch the border
                                            }}
                                        /> :
                                        <img
                                            src={imageSrc}
                                            alt="Signature"
                                            style={{
                                                height: "auto",
                                                position: "relative", // Aligns with the div
                                                top: "-2px",
                                                right: "-110px",
                                                maxWidth: "150px",

                                                // Moves the image upwards to touch the border
                                            }}
                                        />
                                    }
                                </div>
                                <p class="text-center"> <b>{signatureData?.officerNameBeng ? signatureData?.officerNameBeng : signatureData?.officerName}</b></p>
                                <p class="text-center"> <b>{signatureData?.officerDesigBeng ? signatureData?.officerDesigBeng : signatureData?.officerDesig}</b></p>
                                <p class="text-center"> <b>{certificateDownloadData?.GPNameBeng ? certificateDownloadData?.GPNameBeng : certificateDownloadData?.GPName}</b></p>
                                <p class="text-center"> <b>{certificateDownloadData?.BlockNameBeng}, {certificateDownloadData?.DistrictBeng}</b></p>
                            </div>
                        </div>
                    </div>
                    <p style={{ bottom: "170px", position: "absolute", fontSize: "12px" }}><i>To verify the authenticity of this certificate, please visit https://wbpms.in/citizen/#/certificate-check</i></p>

                </div> :
                //for nepali certificate
                <div class="grid-container xyx" ref={certificateRef} style={{ position: "relative" }}>
                    {/* <img src={certificateFormate} style={{position:'absolute'}}/> */}
                    <div class="cell text-center">
                        <br></br>
                        <h4 style={{ marginTop: "15px" }}><b>{certificateDownloadData?.GPNameBeng}</b></h4>
                        <h5 style={{ marginTop: "-12px" }}><b>{signatureData?.gpAddressbeng}</b></h5>
                    </div>


                    <div class="cell">
                        <div class="grid-x grid-padding-x crtno" style={{ marginTop: "60px" }}>
                            <div class="large-6">
                                <p class="text-left">प्रमाणपत्र नम्बर: <b>{certificateDownloadData?.ApplicationId}</b></p>
                            </div>
                            <div class="large-6">
                                <p class="text-right">मिति: <b>{certificateDownloadData?.ApproveDate}</b></p>
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <div class="cell text-center">
                        <h4 style={{ marginBottom: "20px" }}>
                            <b><u>TO WHOM IT MAY CONCERN</u></b>
                        </h4>
                    </div>
                    <br></br>
                    <div class="grid-x grid-padding-x resi divmargin" style={{ marginBottom: "20px " }}>
                        <div class="cell large-10 medium-10 small-12">
                            <p>
                                यसद्वारा यो प्रमाणित गरिन्छ कि, <b>{certificateDownloadData?.Gender === "Mr." ? "श्री" : certificateDownloadData?.Gender === "Mrs." ? "श्रीमती" : certificateDownloadData?.Gender === "Miss" ? "सुश्री" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b>, <b>{certificateDownloadData?.RelationGurdianBengali}</b> : <b>{certificateDownloadData?.GurdianNameBengali}</b>, <b>{certificateDownloadData?.AddressBengali}</b>, हुलाक कार्यालय - <b>{certificateDownloadData?.PostOfficeBengali}</b>, प्रहरी स्टेशन.- <b>{certificateDownloadData?.PoliceStationBengali}</b>, जिल्ला- <b>{certificateDownloadData?.DistrictNepali}</b>, पिन- <b>{certificateDownloadData?.PinBengali}</b> -पश्चिम बङ्गाल लाई  राम्रोसित चिन्दछु।
                                <br></br>
                                <br></br>
                                उनी <b>{certificateDownloadData?.RelationGurdianBengali}</b> <b>{certificateDownloadData?.AddressBengali}</b>, हुलाक कार्यालय- <b>{certificateDownloadData?.PostOfficeBengali}</b>,  प्रहरी स्टेशन- <b>{certificateDownloadData?.PoliceStationBengali}</b>, जिल्ला- <b>{certificateDownloadData?.DistrictNepali}</b>, पिन- <b>{certificateDownloadData?.PinBengali}</b>, पश्चिम बंगाल, को स्थायी बासिन्दा हुनुहुन्छ।
                            </p>
                        </div>

                        

                            <div class="cell large-2 medium-2 small-12 text-right">
                                <img src={certificateDownloadData?.ApplicantImageBase64} style={{ width: "100%", border: "1px solid #000", padding: "5px", marginTop: "-40px" }} />
                            </div> 
                    </div>

                    {/* unmarried Certficate */}
                    {certificateDownloadData?.UnmarriedCertificate > 0 ?
                        <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px" }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    मेरो ज्ञान अनुसार, <b>{certificateDownloadData?.Gender === "Mr." ? "श्री" : certificateDownloadData?.Gender === "Mrs." ? "श्रीमती" : certificateDownloadData?.Gender === "Miss" ? "सुश्री" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b> अविवाहित छ।

                                </p>
                            </div>
                        </div>
                        : ""}

                    {/* caste certificate */}
                    {certificateDownloadData?.CastCertificate > 0 ?
                        <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px" }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    उनी <b>{certificateDownloadData?.SubCast}</b> समुदायको अनि, <b>{certificateDownloadData?.Cast}</b> वर्गको हो।

                                </p>
                            </div>
                        </div>
                        : ""}

                    {/* <!-- income --> */}
                    {certificateDownloadData?.IncomeCertificate > 0 ?

                        <div class="grid-x grid-padding-x income divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    <b>{certificateDownloadData?.IncomeFinYear}</b> आर्थिक वर्ष को लागि सबै स्रोतबाट उनको कुल वार्षिक पारिवारिक आम्दानी करिब रु <b>{certificateDownloadData?.AnnualIncome}</b>/- ( <b>{certificateDownloadData?.AnnualIncomeWord}</b> ) ।
                                </p>
                            </div>
                        </div> : ""}

                    {/* <!-- Distance --> */}
                    {certificateDownloadData?.DistanceCertificate > 0 ?

                        <div class="grid-x grid-padding-x distance divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    उनको निवास र <b>{certificateDownloadData?.ResidenceLocation}</b> बीचको अनुमानित दूरी <b>{certificateDownloadData?.ResidenceDistance}</b> किलोमिटरमा छ
                                </p>
                            </div>
                        </div> : ""}

                    {/* <!-- Same Person --> */}
                    {certificateDownloadData?.SamePersonCertificate > 0 ?

                        <div class="grid-x grid-padding-x same divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    <b>{certificateDownloadData?.Gender === "Mr." ? "श्री" : certificateDownloadData?.Gender === "Mrs." ? "श्रीमती" : certificateDownloadData?.Gender === "Miss" ? "सुश्री" : ""}</b> <b>{certificateDownloadData?.ApplicantName}</b> र <b>{certificateDownloadData?.Gender === "Mr." ? "श्री" : certificateDownloadData?.Gender === "Mrs." ? "श्रीमती" : certificateDownloadData?.Gender === "Miss" ? "सुश्री" : ""}</b> <b>{certificateDownloadData?.SamePersonNewName}</b> एउटै व्यक्ति हुन्। उनका  <b>{certificateDownloadData?.RelationGurdianBengali}</b> : <b>{certificateDownloadData?.GurdianNameBengali}</b>। उनको जन्म मिति <b>{certificateDownloadData?.DOBBengali}</b> हो।

                                </p>
                            </div>
                        </div> : ""}

                    {/* Character Certificate/All  */}
                    {certificateDownloadData?.CharacterCertificate > 0 ?

                        <div class="grid-x grid-padding-x character divmargin" style={{ marginBottom: "20px " }}>
                            <div class="cell large-12 medium-12 small-12">
                                <p>
                                    <b>{certificateDownloadData?.Gender === "Mr." ? "श्री" : certificateDownloadData?.Gender === "Mrs." ? "श्रीमती" : certificateDownloadData?.Gender === "Miss" ? "सुश्री" : ""}</b> <b>{certificateDownloadData?.ApplicatNameBengali}</b> इमानदार, जिम्मेवार र प्रशंसनीय नैतिक चरित्र भएका हुन् । उहाँलाई जीवनमा सफलताको कामना गर्दछु।
                                </p>
                            </div>
                        </div> : ""}

                    <div class="cell">
                        <div class="grid-padding-x grid-x">
                            <div class="large-6 cell text-center">

                                <QRCodeCanvas value={JSON.stringify(data)}

                                    size={100}
                                />
                                <p class="text-center" style={{ fontSize: "10px" }}><i>https://wbpms.in</i></p>
                                <p class="text-center" style={{ fontSize: "10px" }}><i>Certificate Valid for 6 Months</i></p>
                            </div>

                            <div class="large-6 cell" style={{ marginTop: "30px" }}>

                                <div>
                                    {certificateDownloadData?.ApplicantImageBase64 ?
                                        <img
                                            src={imageSrc}
                                            alt="Signature"
                                            style={{
                                                height: "auto",
                                                position: "relative", // Aligns with the div
                                                top: "-2px",
                                                right: "-110px",
                                                maxWidth: "150px",

                                                // Moves the image upwards to touch the border
                                            }}
                                        /> :
                                        <img
                                            src={imageSrc}
                                            alt="Signature"
                                            style={{
                                                height: "auto",
                                                position: "relative", // Aligns with the div
                                                top: "-2px",
                                                right: "-110px",
                                                maxWidth: "150px",

                                                // Moves the image upwards to touch the border
                                            }}
                                        />
                                    }
                                </div>
                                <p class="text-center"> <b>{signatureData?.officerNameBeng ? signatureData?.officerNameBeng : signatureData?.officerName}</b></p>
                                <p class="text-center"> <b>{signatureData?.officerDesigBeng ? signatureData?.officerDesigBeng : signatureData?.officerDesig}</b></p>
                                <p class="text-center"> <b>{certificateDownloadData?.GPNameBeng ? certificateDownloadData?.GPNameBeng : certificateDownloadData?.GPName}</b></p>
                                <p class="text-center"> <b>{certificateDownloadData?.BlockNameNepali}, {certificateDownloadData?.DistrictNepali}</b></p>

                            </div>
                        </div>
                    </div>
                    <p style={{ bottom: "170px", position: "absolute", fontSize: "12px" }}><i>To verify the authenticity of this certificate, please visit https://wbpms.in/citizen/#/certificate-check</i></p>


                </div>}

            {certificateDownloadData?.ApplicantImageBase64 ?
                <div>
                    <br></br>
                    <button

                        onClick={handleDownload}
                        className="btn mt-4 bg-blue-500 text-white px-4 py-2 rounded"
                        style={{ marginLeft: "700px" }}
                    >
                        {/* {certificateDownloadData?.SaveDate} */}
                        Download Certificate
                    </button>
                </div>
                : ""}
        </>
    )
}

export default BengaliCertificate;